import { Spacer } from "@hackthenorth/north";
import { Button, Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Modal } from "src/shared/components";

import { THasIdModalState } from "../hooks/useHardwareIdTracking";

type Props = {
  open: boolean;
  modalState: THasIdModalState | null;
  onConfirm: (hasId: boolean) => void;
};

const HasIdConfirmationModal: React.FC<Props> = ({
  open,
  modalState,
  onConfirm,
}) => {
  if (!modalState) return null;

  const { mode, userName, currentHasId } = modalState;

  if (mode === "return" && !currentHasId) return null;

  const copy =
    mode === "checkout"
      ? currentHasId
        ? {
            title: "ID already on file",
            body: (
              <>
                This is <strong>{userName}&apos;s</strong> first checked-out
                item, and we already have their ID on file as hardware
                collateral. Is that still the case?
              </>
            ),
            noLabel: "No, don't have it",
            yesLabel: "Yes, still have it",
          }
        : {
            title: "Confirm ID collected",
            body: (
              <>
                This is <strong>{userName}&apos;s</strong> first checked-out
                item. Have we taken their ID as collateral?
              </>
            ),
            noLabel: "No",
            yesLabel: "Yes",
          }
      : {
          title: "Confirm ID returned",
          body: (
            <>
              <strong>{userName}</strong> just returned their last item. Have we
              returned their ID?
            </>
          ),
          noLabel: "No, not yet",
          yesLabel: "Yes, returned",
        };

  const noValue = mode === "checkout" ? false : true;
  const yesValue = mode === "checkout" ? true : false;

  return (
    <StyledModal
      isOpen={open}
      width="480px"
      height="auto"
      overlayStyle={{ zIndex: 10001 }}
    >
      <Text type="h3">{copy.title}</Text>
      <Spacer height={16} />
      <Text type="body1">{copy.body}</Text>
      <Spacer height={24} />
      <Actions>
        <Button color="secondary" size="md" onClick={() => onConfirm(noValue)}>
          {copy.noLabel}
        </Button>
        <Button color="primary" size="md" onClick={() => onConfirm(yesValue)}>
          {copy.yesLabel}
        </Button>
      </Actions>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-height: 90vh;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export default HasIdConfirmationModal;
